// @flow

import Logger from "app/lib/Logger";
import EventEmitter from 'eventemitter3';

// Ensure Websocket handler is initialised whenever LegacyDispatcher has been
// This is done because Websocket is an intermediary between the CableStore
// and LegacyDispatcher, and rarely called itself. This means that without
// being explicitly imported somewhere, it wouldn't pass events!
//
// It makes more sense for it to be initialised here, as LegacyDispatcher will
// always be initialised by its consumers, and thus things dependent upon
// the Websocket subsystem. In the future I believe Websocket should become a
// part of the LegacyDispatcher or the system that succeeds it.
import './Websocket';

class LegacyDispatcher extends EventEmitter {
  on(events, callback) {
    return events.split(" ").map((evt) => super.on(evt, callback));
  }

  off(events, callback) {
    return events.split(" ").map((evt) => super.off(evt, callback));
  }

  emit(event, a1, a2, a3, a4, a5) {
    if (this.debug) {
      Logger.info("[Legacy Dispatcher]", ...arguments);
    }
    return super.emit(event, a1, a2, a3, a4, a5);
  }
}

export default new LegacyDispatcher();
